var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {
    'width_fill height_fill parent preloaderContainer h-centered relative': true,
    'v-start': _vm.verticalPosition === 'top',
    'v-centered': _vm.verticalPosition === 'center',
    'v-end': _vm.verticalPosition === 'bottom'
}, _obj[_vm.className] = _vm.className, _obj )},[_c('svg',{class:( _obj$1 = {}, _obj$1['preloader_sticky'] = _vm.isSticky, _obj$1 ),attrs:{"aria-live":"assertive","role":"alert","aria-label":"Загрузка страницы","height":"1em","width":"1em","viewbox":"0 0 44 44"}},[_c('use',{attrs:{"xlink:href":"#pagePreloader"}})])])
var _obj;
var _obj$1;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39faac95","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/ViewPreloader.vue
// module id = null
// module chunks = 